const PREFIX_LEN = 12;

/** Redact a Zoom onAuthorized event so diagnostics never carry a usable code. */
export function redactAuthEvent(
  event: { code?: string; state?: string },
  expectedState: string,
): Record<string, unknown> {
  return {
    codePrefix: event.code ? `${event.code.slice(0, PREFIX_LEN)}…` : null,
    hasCode: Boolean(event.code),
    stateMatches: Boolean(event.state) && event.state === expectedState,
  };
}
